import React from 'react';
import { createRoot } from 'react-dom/client';
import { initMicroFrontendConfig } from '@cko/dashboard-shared';

import { initialiseDatadogRum } from './integrations/datadogRum';
import { getLaunchDarklyProvider } from './integrations/LaunchDarkly/launchDarkly';
import App from './App';
import { MFE_CONFIG } from './environment/mfe';
import { APP_CONFIG } from './environment/app';
import { KILLSWITCH_CONFIG } from './environment/killswitches';

(async () => {
  initMicroFrontendConfig(MFE_CONFIG.microFrontendConfigs, APP_CONFIG.environment);

  const rootElement = document.getElementById('root');
  if (!rootElement) {
    throw new Error('Element with id `root` does not exist');
  }

  if (!KILLSWITCH_CONFIG.datadogDisabled) {
    initialiseDatadogRum();
  }

  if (KILLSWITCH_CONFIG.launchdarklyDisabled) {
    return createRoot(rootElement).render(<App />);
  }

  const LaunchDarklyProvider = await getLaunchDarklyProvider();

  if (!LaunchDarklyProvider) {
    return createRoot(rootElement).render(<App />);
  }

  createRoot(rootElement).render(
    <LaunchDarklyProvider>
      <App />
    </LaunchDarklyProvider>,
  );
})();
